module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_Black_w_0-77d49c05a370c87b99cd4094416206f1.svg";